import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "@mui/material";

import { Button } from "../buttons";

import { CommonDialog, CommonDialogTitle, CommonDialogContent, CommonDialogActions } from "./common-dialog.jsx";

import "./style.less";

const SuccessSaveDataDialog: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
    const intl = useIntl();

    return (
        <CommonDialog open={!!open} className="succes-save-data-dialog">
            <CommonDialogTitle withoutCloseIcon={false} title={intl.formatMessage({id:"common.success-save-data-dialog-title"})} onClose={onClose} />

            <CommonDialogContent>
                <Typography className="succes-save-data-dialog-message">
                    <FormattedMessage id="common.success-save-data-dialog-message" />
                </Typography>
            </CommonDialogContent>

            <CommonDialogActions>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        color: "var(--font-4)",
                        borderColor: "var(--font-4)",
                    }}
                >
                    <FormattedMessage id="common.btn-close" />
                </Button>
            </CommonDialogActions>
        </CommonDialog>
    );
};

export default SuccessSaveDataDialog;
